document.addEventListener('alpine:init', () => {
    Alpine.data('eixosBlock', () => ({
        activeEixo: 0,
        setActive(index) {
            this.activeEixo = index;
        }
    }));
});
